import { Controller } from '@hotwired/stimulus';
import { csrfToken } from '../utils/csrf';

const WIDGET_TAG_NAME = 'trustbox-verified-review-collector';
const WIDGET_READY_TIMEOUT_IN_MS = 10000;

export default class extends Controller {
  static targets = ['widget', 'form', 'loader'];
  static values = { customerData: Object, url: String };

  connect() {
    this.formLoadExpected = false;
    this.completionHandled = false;
  }

  disconnect() {
    this.modal?.dispose();
  }

  async handleCompletion() {
    if (this.completionHandled) return;

    this.completionHandled = true;

    const widgetDefined = await this.widgetDefined();
    if (!widgetDefined) return;

    this.widgetTarget.dispatchEvent(
      new CustomEvent('customerDataResponse', { detail: this.customerDataValue })
    );

    this.modal = new bootstrap.Modal(this.element);
    this.modal.show();
  }

  awaitForm() {
    this.formLoadExpected = true;
    this.loaderTarget.classList.remove('d-none');
  }

  showForm() {
    if (!this.formLoadExpected) return;

    this.formLoadExpected = false;
    this.loaderTarget.classList.add('d-none');
    this.formTarget.classList.remove('d-none');
    this.widgetTarget.classList.add('d-none');
    fetch(this.urlValue, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken() },
    });
  }

  widgetDefined() {
    return Promise.race([
      customElements.whenDefined(WIDGET_TAG_NAME).then(() => true),
      new Promise((resolve) => setTimeout(() => resolve(false), WIDGET_READY_TIMEOUT_IN_MS)),
    ]);
  }
}
